import { render, staticRenderFns } from "./TInputCard.vue?vue&type=template&id=5cd64010&scoped=true&"
import script from "./TInputCard.vue?vue&type=script&lang=js&"
export * from "./TInputCard.vue?vue&type=script&lang=js&"
import style0 from "./TInputCard.vue?vue&type=style&index=0&id=5cd64010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd64010",
  null
  
)

/* custom blocks */
import block0 from "./TInputCard.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports